import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["copyable"];

  static values = { notification: String };

  async copy() {
    await navigator.clipboard.writeText(this.copyableTarget?.textContent?.trim() || "");

    if (this.hasNotificationValue) {
      window.displayFlash("success", this.notificationValue);
    }
  }
}
